import type { ApolloClient } from '@apollo/client'
import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'
import { CategoryFilterDataDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { createAsyncFilterWithQuery } from './createAsyncFilterWithQuery'

export const createCategoryAsyncFilter = (
  apolloClient: ApolloClient<unknown>,
  companyId: number
): FilterDefinition =>
  createAsyncFilterWithQuery({
    label: i18n.t('expenses_v2.list.header.category'),
    apolloClient,
    query: CategoryFilterDataDocument,
    variables: { companyIds: [companyId] },
    mapData: (data) => {
      const allCategories = data?.finance?.categories.nodes || []
      const hasPerDiemsFeature =
        data?.companies?.featureAvailabilitiesConnection?.nodes.find(
          (node) => node.id === 'expenses_per_diems'
        )?.available ?? false

      // Filter out per-diem category if feature is not available
      const categories = hasPerDiemsFeature
        ? allCategories
        : allCategories.filter((category) => category.identifier !== 'perdiem')

      return categories.map((cat) => ({
        label: cat.label,
        value: cat.identifier,
      }))
    },
  })
